import React, { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";

export const PdfPreviewModal = ({ open, onOpenChange, praticaId, titolo }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  React.useEffect(() => {
    if (!open) { if (url) URL.revokeObjectURL(url); setUrl(null); setError(null); return; }
    let active = true;
    api.get(`/pratiche/${praticaId}/report.pdf`, { responseType: "blob" })
      .then((res) => active && setUrl(URL.createObjectURL(res.data)))
      .catch(() => active && setError("Impossibile generare il report PDF"));
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, praticaId]);

  const download = () => {
    const a = document.createElement("a");
    a.href = url;
    a.download = `report-due-diligence-${(titolo || praticaId).replace(/\s+/g, "_")}.pdf`;
    document.body.appendChild(a); a.click();
    if (a.parentNode === document.body) document.body.removeChild(a);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="pdf-preview-modal" className="max-w-5xl h-[90vh] flex flex-col bg-[#121824] border-slate-800 text-slate-100">
        <DialogHeader className="flex-row items-center justify-between space-y-0 pr-8">
          <DialogTitle className="font-heading">Anteprima Report di Due Diligence</DialogTitle>
          <button data-testid="pdf-download-btn" disabled={!url} onClick={download}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-500 text-slate-900 text-sm font-semibold disabled:opacity-40">
            <FileDown className="h-4 w-4" /> Scarica PDF
          </button>
        </DialogHeader>
        <div className="flex-1 min-h-0 rounded-lg overflow-hidden bg-[#0B0F17] border border-slate-800 flex items-center justify-center">
          {error ? <p data-testid="pdf-preview-error" className="text-rose-400 text-sm">{error}</p>
            : url ? <iframe data-testid="pdf-preview-frame" title="Report PDF" src={`${url}#toolbar=0&view=FitH`} className="w-full h-full" />
            : <div className="flex items-center gap-2 text-slate-400 text-sm"><Loader2 className="h-4 w-4 animate-spin" /> Generazione report in corso…</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
